export const homeDestination = Object.freeze({ name: 'HolidaysPublicUserCompaniesPage' })
